import $ from 'jquery';

const $html = $('html');

let $menu = $('.js-menu');
let $menuOverlay = $('.js-menu-overlay');
let $menuToggle = $('.js-menu-toggle');
let $menuContent = $menu.find('.js-menu-content');

// Toggle menu when clicking any `.js-menu-toggle` element
$menuToggle.on('click', function (event) {
  $menu.toggleClass('is-toggled');
  $menuToggle.toggleClass('is-toggled');
  $menuOverlay.toggleClass('is-toggled');
  $html.toggleClass('is-locked');

  let $this = $(this);
  // $menuOverlay.width($this.width());
  // $menuOverlay.height($this.height());
  // $menuOverlay.css({
  //   top: $this.offset().top + ($this.height()/2),
  //   left: $this.offset().left + ($this.width()/2),
  // });
});

// Toggle menu when clicking inside menu itself
$menu.on('click', function (event) {
  $menu.toggleClass('is-toggled');
  $menuToggle.toggleClass('is-toggled');
  $menuOverlay.toggleClass('is-toggled');
  $html.toggleClass('is-locked');
});

// Prevent clicking content inside from closing menu
$menuContent.on('click', function (event) {
  event.stopPropagation();
});

// Handle toggling parent "dropdown"

const $menuItems = $('.menu__item--parent');
const $menuLinks = $('.menu__item--parent > .menu__link');

$menuLinks.on('click', function (event) {
  event.preventDefault();
  const $menuLink = $(this);
  const $menuItem = $menuLink.parent();
  if ($menuItem.hasClass('is-toggled')) {
    $menuItems.removeClass('is-toggled');
    $menuLinks.removeClass('is-toggled');
  } else {
    $menuItems.removeClass('is-toggled');
    $menuLinks.removeClass('is-toggled');
    $menuLink.addClass('is-toggled');
    $menuItem.addClass('is-toggled');
  }
});
